import {
  Component,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
  inject,
  DestroyRef,
} from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterState,
  TitleStrategy,
  RouterOutlet,
} from '@angular/router';
import { initFlowbite } from 'flowbite';
import * as AOS from 'aos';
import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from '@angular/cdk/layout';
import { environment } from '../environments/environment';
import { Meta } from '@angular/platform-browser';
import { CacheService } from './services/cache.service';
import Intercom from '@intercom/messenger-js-sdk';
import { filter } from 'rxjs/operators';
import { GradeBoosterStore } from './stores/grade-booster-store';
import { SubscriptionStore } from './stores/subscription-store';
import { FeatureStore } from './stores/feature-store';
import { OnboardingStore } from './stores/onboarding-store';
import {
  MatDrawerContainer,
  MatSidenav,
  MatDrawer,
  MatDrawerContent,
} from '@angular/material/sidenav';
import { SideNavState } from './components/side-nav-menu/menu-types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FullscreenService } from './services/fullscreen.service';
import { SidenavService } from './services/sidenav.service';
import { AttributionService } from './services/attribution.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { SideNavMenuComponent } from './components/side-nav-menu/side-nav-menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { TermsAndConditionsModalComponent } from './components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { ResultsDayModalComponent } from './components/results-day-modal/results-day-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [],
  imports: [
    MatDrawerContainer,
    MatDrawer,
    NgClass,
    SideNavMenuComponent,
    MatDrawerContent,
    RouterOutlet,
    FooterComponent,
    TermsAndConditionsModalComponent,
    ResultsDayModalComponent,
    AsyncPipe,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatDrawerContainer) drawerContainer!: MatDrawerContainer;

  successModelText: any = '';
  title = 'lightuptutoring-angular';
  isLoggedIn: boolean = false;
  formError = '';
  isSubmitted: boolean = false;
  isSubscribed: boolean = false;
  hasGradeBooster: boolean = false;
  gradeBoosterCourses: any[] = [];
  hasLiveLessons: boolean = false;
  document: any;
  innerWidth: number;
  targetDate: Date;
  query: string = '';
  lessons: any[] = [];
  isIntroPage: boolean = false;
  isAccountPage: boolean = false;
  data: any[];
  homeLink: string = environment.homeLink;
  hasLastMinuteRevision: boolean = false;
  private visitedPages: any[] = [];
  IspopupOpen: boolean = false;
  counter: any = 0;
  isPurchasePage: boolean;
  //used to determine what the sidenav behavior is
  sideNavState: SideNavState = SideNavState.FULL;
  isSmallScreen: boolean = false;
  sidenavOpen: boolean = false;
  private destroyRef = inject(DestroyRef);
  fullscreenService = inject(FullscreenService);
  sidenavService = inject(SidenavService);
  attributionService = inject(AttributionService);
  fullscreen$ = this.fullscreenService.isFullscreen$;
  prohibitedNavbarRoutes = [
    '/register',
    '/waiting-confirmation',
    '/login',
    '/forgot-password',
    '/essay-marking/skill',
  ];
  isNavbarProhibited: boolean = false;
  isTCModalOpen = false;
  isPaymentImages: boolean = false;
  private gradeBoosterStore = inject(GradeBoosterStore);
  private subscriptionStore = inject(SubscriptionStore);
  private featureStore = inject(FeatureStore);
  private onboardingStore = inject(OnboardingStore);
  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private cacheService: CacheService,
    private meta: Meta,
    private titleStrategy: TitleStrategy,
  ) {
    if (environment.production) {
      this.meta.addTag({
        'http-equiv': 'Content-Security-Policy',
        content: 'upgrade-insecure-requests',
      });
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        this.determineFullscreen(url);
        this.determineFooterImages(url);
        this.isIntroPage = event.url === '/intro';
        this.isAccountPage = event.url.startsWith('/account');
        this.isPurchasePage = event.url.startsWith('/pack-purchase');
        this.isNavbarProhibited = this.prohibitedNavbarRoutes.some((route) =>
          event.url.startsWith(route),
        );
        this.setIsLoggedIn();

      }
    });

    this.sidenavService.toggleSidenav$.subscribe(() => {
      this.sidenav.toggle();
    });

    this.sidenavService.navigateToDashboard$.subscribe(() => {
      this.navigateToDashboard();
    });

    this.setIsLoggedIn();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Capture the URL of the visited page
        if (
          this.visitedPages.lastIndexOf('/pack-purchase?status=success') !== -1
        ) {
          this.visitedPages = [];
        } else {
          this.visitedPages.push(event.urlAfterRedirects); // Store the route in visitedPages
        }
        if (
          this.visitedPages.lastIndexOf('/pack-purchase') !== -1 &&
          window.location.pathname !== '/pack-purchase' &&
          !this.IspopupOpen &&
          this.isLoggedIn
        ) {
          this.counter++;
        }
      });

    router.events.subscribe((event: any) => {
      if (event.navigationTrigger === 'popstate') {
        const elements = document.getElementsByClassName('z-40');
        while (elements.length > 0) {
          elements[0].remove();
          document.body.className = document.body.className.replace(
            'overflow-hidden',
            '',
          );
        }
      }
      if (event.navigationTrigger === 'imperative') {
        this.isSubmitted = false;
      }
    });
  }

  ngAfterViewInit() {
    if (environment.noIndex) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
    this.cdr.detectChanges();
  }

  determineFullscreen(url: string) {
    // Check if it's a lesson route
    if (this.fullscreenService.isFullscreenRoute(url)) {
      this.fullscreenService.enterFullscreen();
    } else {
      this.fullscreenService.exitFullscreen();
    }
  }

  determineFooterImages(url: string) {
    const imageUrls = ['/subscribe', '/membership'];
    this.isPaymentImages = imageUrls.some((route) => url.startsWith(route));
  }

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];

    if (
      parent &&
      parent.snapshot &&
      this.titleStrategy.getResolvedTitleForRoute(parent.snapshot)
    ) {
      data.push(this.titleStrategy.getResolvedTitleForRoute(parent.snapshot));
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
    sessionStorage.removeItem('isPhoneModalShown');
    sessionStorage.removeItem('exitPopupShown');
    this.router.navigateByUrl('/login');
  }

  setIsLoggedIn() {
    setTimeout(function () {
      //added as when page changes, mobile menu dropdown stopped working
      initFlowbite();
    }, 500);
    if (this.authService.isUserLoggedIn()) {
      this.isLoggedIn = true;
      const userData = this.authService.getUserData();

      if (userData) {
        this.isSubscribed = this.subscriptionStore.isSubscribed();
        this.hasGradeBooster = this.gradeBoosterStore.hasGradeBooster();
        this.gradeBoosterCourses = this.gradeBoosterStore.gradeBoostersRef();
        this.hasLiveLessons = this.featureStore.hasLiveLessons();
        Intercom({
          app_id: 'ygqd42m4',
          user_id: userData.id?.toString(), // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
          name: userData.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
          email: userData.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
          user_hash: userData.hash_hmac_key,
          hide_notifications: true,
        });
      }
      let body = document.getElementsByTagName('body')[0];
      body.classList.add('user-logged-in');
    } else {
      this.isLoggedIn = false;
      this.isSubscribed = false;

      Intercom({
        app_id: 'ygqd42m4',
      });

      let body = document.getElementsByTagName('body')[0];
      body.classList.remove('user-logged-in');
    }
  }

  ngOnInit() {
    this.attributionService.capture(window.location.search);
    const originalAddEventListener = EventTarget.prototype.addEventListener;

    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Handset])
      .subscribe((result) => {
        this.isSmallScreen = result.matches;
        if (this.isSmallScreen) {
          this.sideNavState = SideNavState.MOBILE;
          //user can toggle it if they need it
          this.sidenavOpen = false;
        } else {
          this.sideNavState = SideNavState.FULL;
          //always open on full screens
          this.sidenav?.open();
          this.sidenavOpen = true;
        }
        this.updateSidenavWidthVar();
      });

    EventTarget.prototype.addEventListener = function (
      type,
      listener,
      options,
    ) {
      if (type === 'scroll' || type === 'keydown') {
        const stackTrace: any = new Error().stack;
        const targetFiles = [
          'flowbite.js',
          'flowbite.min.js',
          '_createPopperInstance',
        ];
        const shouldBlock = targetFiles.some((file) =>
          stackTrace.includes(file),
        );
        if (shouldBlock) {
          return; // Stop Flowbite from adding the event
        }
      }
      return originalAddEventListener.call(this, type, listener, options);
    };
    initFlowbite();

    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          AOS.init({
            once: true, // whether animation should happen only once - while scrolling down
            disable: window.innerWidth <= 768, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            // You can also pass an optional settings object
            // below listed default settings
            // offset: -120,
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
          });
        } else {
          AOS.init({
            once: true, // whether animation should happen only once - while scrolling down
            disable: window.innerWidth <= 768, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            // You can also pass an optional settings object
            // below listed default settings
            // offset: -120,
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
          });
        }
      });

    this.cacheService.cache$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.data = data;
      });
  }

  clearError() {
    this.formError = '';
  }

  removeModalBackdrop() {
    const backdrop = document.querySelector('div[modal-backdrop]');
    const body = document.querySelector('body');
    if (backdrop) {
      backdrop.remove();
    }

    if (body) {
      body.classList?.remove('overflow-hidden');
    }
  }

  ngOnDestroy(): void {
    this.cacheService.clearAll();
  }

  toggleDesktopSidenav() {
    if (this.sideNavState === SideNavState.FULL) {
      this.sideNavState = SideNavState.SLIM;
    } else if (this.sideNavState === SideNavState.SLIM) {
      this.sideNavState = SideNavState.FULL;
    }
    this.updateSidenavWidthVar();
    if (this.drawerContainer) {
      //re calc the amount of space we have for main content
      setTimeout(() => {
        this.drawerContainer.updateContentMargins();
      }, 100);
    }
  }

  /**
   * Exposes the sidenav's current rendered width as a CSS custom property on the document root
   * — mirrors .left-side-nav/.left-side-nav-icon's widths below. mat-drawer-container computes
   * the content area's own margin internally (no CSS var of its own to read), so any
   * position:fixed element elsewhere in the app that needs to avoid the sidenav (fixed ignores
   * ancestor margins entirely) has no other way to know its current width — mobile's drawer is
   * `mode="over"` (overlay, doesn't push content), so it gets 0.
   */
  private updateSidenavWidthVar(): void {
    const width =
      this.sideNavState === SideNavState.FULL
        ? '296px'
        : this.sideNavState === SideNavState.SLIM
          ? '60px'
          : '0px';
    document.documentElement.style.setProperty('--sidenav-width', width);
  }

  toggleSidenav() {
    this.sidenav.toggle();
    this.sidenavOpen = this.sidenav.opened;
  }

  openTCModal(): void {
    this.isTCModalOpen = true;
  }

  closeTCModal(): void {
    this.isTCModalOpen = false;
  }

  navigateToDashboard() {
    if (this.onboardingStore.isComplete() === false) {
      this.router.navigate(['/onboarding']);
      return;
    }

    if (this.isSubscribed) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/free-taster/viewer']);
    }
  }
}
